/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import Vue from 'vue';
import store from '@/store';
import { pseudoLogin, getSessionUser, updateLocation, getEnterprise } from '@/api';
import getCode from '@/utils/getCode';
import WpkReporter from 'wpk-reporter';
import DingTalk from 'DingTalk';
import { auth } from '@/utils/oauth';
import { mode } from '@root/_target.js';

var goUploadLocationBySetting = function () {
  var getCodeToLocate = function getCodeToLocate(DingTalk) {
    getEnterprise({
      code: 10020
    }).then(function (res) {
      if (+res.data.value === 1) {
        setTimeout(function () {
          goUploadLocationBySetting(DingTalk);
        }, 1000 * 60 * 3);
      }
    });
  };

  return function (DingTalk) {
    DingTalk.device.geolocation.get({
      targetAccuracy: 100,
      // 精度半径
      coordinate: 1,
      // 1 高德坐标 2 标准坐标（无address字段）
      withReGeocode: true,
      // 是否返回逆地理编码信息
      useCache: false,
      // 是否缓存（开启后2分钟内再次请求返回缓存信息）
      onSuccess: function onSuccess(_ref) {
        var longitude = _ref.longitude,
            latitude = _ref.latitude,
            address = _ref.address;

        if (longitude && latitude) {
          updateLocation({
            longitude: longitude,
            latitude: latitude,
            mapname: address
          }).catch(function (e) {
            return alert(e);
          });
          getCodeToLocate(DingTalk);
        }
      },
      onFail: function onFail(e) {
        console.error(e);
      }
    });
  };
}();

function routerBefore(_x, _x2, _x3) {
  return _routerBefore.apply(this, arguments);
}

function _routerBefore() {
  _routerBefore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var origin, user, isDingTalk, data, res, _res, _DingTalk, _res2, FORMAL_ENV, wpk;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            origin = next; // rewrite next function

            next = function next() {
              if (to.meta && to.meta.code && !auth(to.meta.code)) {
                origin({
                  name: 'DetailError',
                  params: {
                    routeName: to.meta.name
                  }
                });
              } else {
                origin();
              }
            };

            Vue.prototype.$tpLoadingTar.start();
            user = store.state.globalStore.user;
            isDingTalk = navigator.userAgent.includes('DingTalk');

            if (!(!user || Object.keys(user).length === 0)) {
              _context.next = 46;
              break;
            }

            if (!(process.env.NODE_ENV !== 'production')) {
              _context.next = 18;
              break;
            }

            if (mode === 0) {
              data = {
                userid: 288,
                epid: 30
              }; // 内测 chenbin
            } else {
              data = {
                userid: 134,
                epid: 6
              }; // 开发 chenbin
            } // let data = { userid: 52, epid: 6 } // 开发 定国
            // let data = { userid: 310, epid: 30 } // 内测 lx


            _context.next = 10;
            return pseudoLogin(data);

          case 10:
            _context.next = 12;
            return getSessionUser();

          case 12:
            res = _context.sent;
            store.commit('globalStore/_user', res.data);
            Vue.prototype.$DingTalk = DingTalk;
            next();
            _context.next = 44;
            break;

          case 18:
            _context.prev = 18;

            if (isDingTalk) {
              _context.next = 27;
              break;
            }

            // 在浏览器 则已登陆 直接获取sessionUser
            Vue.prototype.$DingTalk = DingTalk;
            _context.next = 23;
            return getSessionUser();

          case 23:
            _res = _context.sent;
            store.commit('globalStore/_user', _res.data);
            _context.next = 36;
            break;

          case 27:
            _context.next = 29;
            return getCode.install(Vue);

          case 29:
            _DingTalk = _context.sent;
            Vue.prototype.$DingTalk = _DingTalk;
            goUploadLocationBySetting(_DingTalk);
            _context.next = 34;
            return getSessionUser();

          case 34:
            _res2 = _context.sent;
            store.commit('globalStore/_user', _res2.data);

          case 36:
            FORMAL_ENV = /^https?:\/\/(?:www|dingtalk).zhongyifu.cn/gi; // 正式环境

            if (FORMAL_ENV.test(window.location.href)) {
              // error监控平台
              wpk = new WpkReporter({
                bid: 'dta_2_3185',
                rel: '2.9.5',
                spa: true,
                uid: sessionStorage.getItem('[smy-vux] - wpkReporter/uid')
              });
              wpk.installAll();
            }

            next();
            _context.next = 44;
            break;

          case 41:
            _context.prev = 41;
            _context.t0 = _context["catch"](18);
            alert(JSON.stringify(_context.t0));

          case 44:
            _context.next = 47;
            break;

          case 46:
            next();

          case 47:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[18, 41]]);
  }));
  return _routerBefore.apply(this, arguments);
}

function routerAfter(to, from, next) {
  if (!to.name || to.name === 'Error') {
    Vue.prototype.$tpLoadingTar.error();
  } else {
    Vue.prototype.$tpLoadingTar.finish();
    store.commit('globalStore/_isInMain', ['Home', 'Operation', 'Order', 'Mine', 'Event'].indexOf(to.name) !== -1); // 关闭加载进度条

    if (to.meta.name && Vue.prototype.$DingTalk) {
      if (to.name === 'AcceptDealWith') {
        setTimeout(function () {
          document.title = to.meta.name[to.params.code];
          Vue.prototype.$DingTalk.biz.navigation.setTitle({
            title: to.meta.name[to.params.code]
          });
        }, 100);
      } else {
        document.title = to.meta.name;
        Vue.prototype.$DingTalk.biz.navigation.setTitle({
          title: to.meta.name
        });
      }
    }
  }
}

export default {
  routerBefore: routerBefore,
  routerAfter: routerAfter
};